module.exports = __webpack_public_path__ + "img/card_run.06a63e65.gif";